import { Menu, Icons, MenuProps, Select, Button, Form, FormInstance, Dropdown } from '@pankod/refine-antd'
import { useGetIdentity } from '@pankod/refine-core'
import { useUserContext } from 'context/user'
import React, { useEffect, useState } from 'react'

type MenuItem = Required<MenuProps>['items'][number]

const { AppstoreOutlined, UserOutlined, } = Icons

const { Option } = Select

type FilterProps = {
  changeFilters: any
  source: string
  percent: any
  filterByCompletionStatus: any
}

export const MoreFilter: React.FC<FilterProps> = ({ changeFilters, source, percent, filterByCompletionStatus }) => {
  const { data: user } = useGetIdentity()
  const role = user?.defaultRole
  const {  userRole,qcreatorList,qapproverList,qreviewerList,vcreatorList } = useUserContext()
  
  const formRef = React.createRef<FormInstance>()
 
 
  const onChange = (value: string) => {
    // alert(`selected ${value}`)
    return false
  }

  
  

  const menu = (
    <Menu mode="vertical">
      {userRole !== 'qcreator' && userRole !== 'variantcreator' && (
        <>
          <Menu.Item key="by_creator" icon={<UserOutlined />} style={{ cursor: 'initial' }}>
            <Select
              showSearch
              allowClear
              placeholder="By Creator"
              optionFilterProp="children"
              onChange={(value: string) => changeFilters('question_creator', value, 'eq')}
              onClick={e => e.stopPropagation()}
              // onSearch={onSearch}
              // filterOption={(input, option) =>
              //   (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase())
              // }
            >
              {qcreatorList.length > 0 &&
                qcreatorList?.map(item => (
                  <Option key={item?.id} value={item?.id}>
                    {`${item?.displayName} (QC)`}
                  </Option>
                ))}

              {/* {qvariantList.length > 0 &&
                qvariantList?.map(item => (
                  <Option key={item?.user?.id} value={item?.user?.id}>
                    {`${item?.user?.displayName} (VC)`}
                  </Option>
                ))} */}
            </Select>
          </Menu.Item>
          <Menu.Item key="by_vc_creator" icon={<UserOutlined />} style={{ cursor: 'initial' }}>
            <Select
              showSearch
              allowClear
              placeholder="By Variant Creator"
              optionFilterProp="children"
              onChange={(value: string) => changeFilters('variant_creator', value, 'eq')}
              onClick={e => e.stopPropagation()}
              // onSearch={onSearch}
              // filterOption={(input, option) =>
              //   (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase())
              // }
            >
              {/* {qcreatorList.length > 0 &&
                qcreatorList?.map(item => (
                  <Option key={item?.user?.id} value={item?.user?.id}>
                    {`${item?.user?.displayName} (QC)`}
                  </Option>
                ))} */}

              {vcreatorList.length > 0 &&
                vcreatorList?.map(item => (
                  <Option key={item?.id} value={item?.id}>
                    {`${item?.displayName} (VC)`}
                  </Option>
                ))}
            </Select>
          </Menu.Item>
        </>
      )}
      {userRole !== 'qreviewer' && (
        <Menu.Item key="by_reviewer" icon={<UserOutlined />} style={{ cursor: 'initial' }}>
          <Select
            showSearch
            allowClear
            placeholder="By Reviewer"
            optionFilterProp="children"
            onChange={(value: string) => {
              if (source === 'Paper Work Requests') {
                changeFilters('paperWorkRequestReviewers.user_id', value, 'eq')
              } else {
                changeFilters('workRequestReviewers.user_id', value, 'eq')
              }
            }}
            onClick={e => e.stopPropagation()}
          >
            {qreviewerList.length > 0 &&
              qreviewerList?.map(item => (
                <Option key={item?.id} value={item?.id}>
                  {item?.displayName}
                </Option>
              ))}
          </Select>
        </Menu.Item>
      )}
      {userRole !== 'qapprover' && (
        <Menu.Item key="by_approver" icon={<UserOutlined />} style={{ cursor: 'initial' }}>
          <Select
            showSearch
            allowClear
            placeholder="By Approver"
            optionFilterProp="children"
            onChange={(value: string) => {
              if (source === 'Paper Work Requests') {
                changeFilters('paperWorkRequestApprovers.approver_id', value, 'eq')
              } else {
                changeFilters('workRequestApprovers.approver_id', value, 'eq')
              }
            }}
            onClick={e => e.stopPropagation()}
          >
            {qapproverList.length > 0 &&
              qapproverList?.map(item => (
                <Option key={item?.id} value={item?.id}>
                  {item?.displayName}
                </Option>
              ))}
          </Select>
        </Menu.Item>
      )}
      <Menu.Item key="by_completion_status" icon={<AppstoreOutlined />} style={{ cursor: 'initial' }}>
        <Select
          allowClear
          placeholder="By Completion Status"
          optionFilterProp="children"
          onChange={(value: string) => {
            changeFilters('completion_status', value, 'between')
          }}
          onClick={e => e.stopPropagation()}
        >
          <Option value="0%-10%">0% - 10%</Option>
          <Option value="10%-20%">10% - 20%</Option>
          <Option value="20%-30%">20% - 30%</Option>
          <Option value="30%-40%">30% - 40%</Option>
          <Option value="40%-50%">40% - 50%</Option>
          <Option value="50%-60%">50% - 60%</Option>
          <Option value="60%-70%">60% - 70%</Option>
          <Option value="70%-80%">70% - 80%</Option>
          <Option value="80%-90%">80% - 90%</Option>
          <Option value="90%-100%">90% - 100%</Option>
        </Select>
      </Menu.Item>
    </Menu>
  )

  return (
    <>
      <Form ref={formRef}>
        <Dropdown overlay={menu}>
          <Button>Filters</Button>
        </Dropdown>
      </Form>
    </>
  )
}
